import React from "react";
import { RateSheetDetails } from "./RateSheetDetails";
import { AdjustmentsDetails } from "./AdjustmentsDetails";
import { FscContent } from "./FscContent";
import { AllAccessorialsDetails } from "../AllAccActivities/AllAccessorialsDetails";

export const RateSheetContent = ({ data }) => {
  const isAccountsScreen = window.location.pathname.includes("accounts")

  const renderLosRateSheet = () => {
    return <RateSheetDetails data={data} />;
  };

  const chargableAccessorials = () => {
    return <AllAccessorialsDetails data={data} objKey={"chargeable_accessorials"} title={"Chargeable Accessorial"}/>
  }

  const includedAccessorials = () => {
    return <AllAccessorialsDetails data={data} objKey={"included_accessorials"} title={"Included Accessorial"}/>
  }

  const renderAdjustments = () => {
    return <AdjustmentsDetails data={data} />;
  };

  const renderFSC = () => {
    return <FscContent data={data} />;
  };

  return (
    <div>
      {renderLosRateSheet()}
      {chargableAccessorials ()}
      {includedAccessorials ()}
      {renderAdjustments()}
      {renderFSC()}
    </div>
  );
};
